import React from 'react';
import { withUnleashClient } from '../../../../v2/core/unleash';
import styles from './index.style';
import { withStyles } from '@material-ui/styles';
import RolesAssignmentV2 from './roles-assignment-v2';
import RolesAssignmentLegacy from './roles-assignment-legacy';

/**
 * Routes between V2 (facilities DataGrid) and legacy (material-table) by CREATE_STAFF_V2.
 * Implementation lives in roles-assignment-v2.js vs roles-assignment-legacy.js (both functional).
 */
function RolesAssignment(props) {
  if (props.createStaffV2Enabled) {
    return <RolesAssignmentV2 {...props} />;
  }
  return <RolesAssignmentLegacy {...props} />;
}

RolesAssignment.defaultProps = {
  facilitiesLocations: [],
  onFacilitiesRefresh: null,
  plaRoleId: null,
  isUserActive: true,
  isViewingOwnProfile: false,
  addFacilityDialogForReactivation: false,
  onReactivationFacilitySubmit: null,
};

export default withStyles(styles)(withUnleashClient(RolesAssignment));
